import { useMyTasksQuery, useWorklistMetricsQuery } from '@common/cache';
import { useNavigate } from 'react-router-dom';
import { IMyTasksFilters } from '../types';
import { useDrawerStore, useMyWorklistStore } from 'store';
import {
  useMyWorklistFilterStore,
  WorklistTabIndexType,
} from 'views/pages/Worklist/MyWorklist/store/filter.store.ts';
import { useEffect } from 'react';

const initialFilters: IMyTasksFilters = {
  search: '',
  programs: [],
  due_date: '',
  category: '',
  team_id: '',
  assignee_id: '',
  location_building_ids: [],
  priorities: ['Overdue', 'Urgent', 'High', 'Medium', 'Low'],
  sort_by: 'due_date',
  sort_order: 'ASC',
  page: 1,
  limit: 100,
  own_tasks_only: true,
  statuses: ['Pending', 'In progress'],
  practice_id: '',
  last_updated_after: '',
  order_categories: [],
  order_types: [],
  task_names: [],
  partner_id: '',
  provider_ids: [],
  appliedFilters: 0,
};

export const useMyWorklist = () => {
  const {
    myWorklistTabIndex,
    tabIndex,
    setTabIndex,
    filters,
    setFilters,
    isFiltersCardOpen,
    resetFilters,
  } = useMyWorklistFilterStore();
  const { providerIds, partnerId } = useMyWorklistStore();
  const { setDrawerOpen, setTaskId, taskId } = useDrawerStore(state => state);

  useEffect(() => {
    setFilters({ provider_ids: providerIds, partner_id: partnerId });
  }, []);

  useEffect(() => {
    return () => resetFilters();
  }, []);

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValue: WorklistTabIndexType,
  ) => {
    setTabIndex(newValue);
  };

  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/worklist/all');
  };

  const handleCloseDrawer = () => {
    setTaskId('');
    setDrawerOpen(false);
  };

  const metrics = useWorklistMetricsQuery({
    own_tasks_only: filters.own_tasks_only ?? false,
  });

  const incompleteCount = metrics?.data?.incomplete_tasks.value || 0;
  const completedTodayCount = metrics?.data?.completed_tasks_today.value || 0;
  const completedThisWeekCount =
    metrics?.data?.completed_tasks_this_week.value || 0;
  const completedThisMonthCount =
    metrics?.data?.completed_tasks_this_month.value || 0;

  const { data: { count: totalCount = 0 } = {} } = useMyTasksQuery({
    ...initialFilters,
    own_tasks_only: filters.own_tasks_only,
  });
  const { data: { count: completedCount = 0 } = {} } = useMyTasksQuery({
    ...initialFilters,
    own_tasks_only: filters.own_tasks_only,
    statuses: ['Completed'],
    priorities: [],
  });

  const { data: { count: inProgressCount = 0 } = {} } = useMyTasksQuery({
    ...initialFilters,
    own_tasks_only: filters.own_tasks_only,
    statuses: ['In progress'],
  });
  const { data: { count: notStartedCount = 0 } = {} } = useMyTasksQuery({
    ...initialFilters,
    own_tasks_only: filters.own_tasks_only,
    statuses: ['Pending'],
  });
  const { data: { count: urgentCount = 0 } = {} } = useMyTasksQuery({
    ...initialFilters,
    own_tasks_only: filters.own_tasks_only,
    priorities: ['Urgent', 'Overdue'],
  });

  return {
    tabIndex,
    handleChangeTab,
    handleNavigate,
    incompleteCount,
    completedTodayCount,
    completedThisWeekCount,
    completedThisMonthCount,
    selectedTaskId: taskId,
    handleCloseDrawer,
    isFiltersCardOpen,
    totalCount,
    completedCount,
    inProgressCount,
    notStartedCount,
    urgentCount,
    myWorklistTabIndex,
  };
};
